<ion-list [inset]="true" color="light">
  <ion-item-divider color="light" *ngIf="props.label" class="p-4">
    <ion-label>{{ translocoService.translate(props.label) }}</ion-label>
  </ion-item-divider>

  <ng-container #fieldComponent></ng-container>
</ion-list>